import type { PluginListenerHandle } from "@capacitor/core";
import { Capacitor } from "@capacitor/core";
import { Keyboard } from "@capacitor/keyboard";
import { type RefObject, useEffect } from "react";

export function useScrollToViewOnKeyboard(
  elementRef: RefObject<HTMLElement | HTMLInputElement | undefined>
) {
  useEffect(() => {
    let keyboardDidShowListener: PluginListenerHandle;

    async function bindListeners() {
      keyboardDidShowListener = await Keyboard.addListener("keyboardDidShow", () => {
        elementRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    }

    if (Capacitor.isNativePlatform()) {
      void bindListeners();
    }

    return () => {
      void keyboardDidShowListener?.remove();
    };
  }, [elementRef]);
}
